export enum LLPStatus {
    Pending = 'pending',
    AdvancePayed = 'advancePayed',
    InstallmentPayed = 'installmentPayed',
    Completed = 'completed'
}

export enum LLPInstallmentStatus {
    Future = 'future',
    Current = 'current',
    Payed = 'payed'
}
